import { createSDK } from "./create";
import { getDeviceInfo } from "./device-detection";
import { sortQueue } from "./sort-queue";

const sdk = createSDK({
	device: getDeviceInfo(),
});

if (window.nubeSDK?.queue) {
	const sorted = window.nubeSDK.queue.sort(sortQueue);

	for (const [method, ...args] of sorted)
		Reflect.apply(sdk[method as "on" | "off" | "send"], sdk, args);
}

window.nubeSDK = sdk;
